// Analytics utility — wraps PostHog
// PostHog project token should be in REACT_APP_POSTHOG_KEY env var

const isProd = process.env.NODE_ENV === 'production';

let posthog = null;

export const initAnalytics = () => {
  if (!isProd) return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;

  import('posthog-js').then(({ default: ph }) => {
    ph.init(key, {
      api_host: 'https://app.posthog.com',
      capture_pageview: true,
      autocapture: false,
      persistence: 'localStorage'
    });
    posthog = ph;
  }).catch(() => {});
};

export const identify = (userId, properties = {}) => {
  if (!posthog) return;
  posthog.identify(userId, properties);
};

export const track = (event, properties = {}) => {
  if (!posthog) return;
  posthog.capture(event, properties);
};

export const resetUser = () => {
  if (!posthog) return;
  posthog.reset();
};

// Pre-defined event helpers
export const Analytics = {
  signupStarted: () => track('signup_started'),
  signupCompleted: (role) => track('signup_completed', { role }),
  loginCompleted: (method) => track('login_completed', { method }),
  jobViewed: (jobId, jobTitle, company) => track('job_viewed', { job_id: jobId, job_title: jobTitle, company }),
  jobApplied: (jobId, jobTitle) => track('job_applied', { job_id: jobId, job_title: jobTitle }),
  internshipApplied: (id) => track('internship_applied', { internship_id: id }),
  paymentInitiated: (plan, amount) => track('payment_initiated', { plan, amount }),
  paymentCompleted: (plan, amount) => track('payment_completed', { plan, amount }),
  profileCompleted: (score) => track('profile_completed', { score }),
  resumeBuilt: () => track('resume_built'),
  assessmentStarted: (title) => track('assessment_started', { title }),
  assessmentPassed: (title, score) => track('assessment_passed', { title, score }),
};

export default Analytics;
